import { reactive } from "@vue/reactivity"
import { postSkillPathQuery } from "@/api";
import { ApiSkillPathOrderByEnum, ApiSkillPathMediaMenuEnum } from "@/enums/api/index";

const states = reactive({
    list: null,
})

const getters = {
    currentSkillPathDetail: (urlName) => {
        const findItem = states.list?.items?.filter(item => item.urlName === urlName) ?? [];
        if (findItem.length === 0) {
            return null;
        }
        return { count: states.list.count, items: findItem };
    }
}

const mutations = {
    updateSkillPathList: data => {
        states.list = data;
    },
}

const actions = {
    skillPathQuery: params => {
        const apiOptions = {
            "urlName": "",
            "MediaMenu": ApiSkillPathMediaMenuEnum.ALL,
            "orderBy": ApiSkillPathOrderByEnum.LATEST,
            ...params
        }
        return postSkillPathQuery(apiOptions)
    },
    getSkillPathList: (params) => {
        let request = null;
        const promise = new Promise((resolve,reject) => {
            const currentDetail = getters.currentSkillPathDetail(params.urlName);

            if (currentDetail) {
                resolve(currentDetail);
            }
            else {
                request = actions.skillPathQuery(params);
                request.then(res => {
                    mutations.updateSkillPathList(res);
                    resolve(res)
                }).catch((res) => {
                    reject(res)
                })
            }
        })
        promise.cancel = () => {
            if (request) {
                request.cancel();
            }
        };
        return promise;
    }
}

export default {
    states,
    getters,
    mutations,
    actions
}